var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import API from "@irati/utils/services/API";
import authentication from "@irati/auth";
import client from "@irati/utils/services/apollo";
import handleOnboardingDoesNotExist from "../helpers/handleOnboardingDoesNotExist";
import codes from "../errorCodes/Onboarding";
import endpoints from "../endpoints";
import onboardingErrorHandler from "./errors/onboardingErrorHandler";
import { getTenantOnboarding, getUserOnboarding, getOnboardingUrl, getTenantOnboardingList, resendWelcomeEmail as resendWelcomeEmailQuery } from "./queries";
import { updateTenantOnboardingStep, updateTenantOnboarding, completeUserOnboardingStep } from "./mutations";
var Onboarding = /** @class */ (function () {
    function Onboarding() {
        this.getTenantOnboarding = function (tenantId, fetchPolicy) {
            var variables = {
                tenantId: tenantId || authentication.userTenant().uuid
            };
            return client.query({ query: getTenantOnboarding, variables: variables, fetchPolicy: fetchPolicy }).then(function (res) { return res.data.getTenantOnboarding; });
        };
        this.getTenantOnboardingList = function (options, fetchPolicy) {
            if (options === void 0) { options = {}; }
            return client.query({ query: getTenantOnboardingList, variables: options, fetchPolicy: fetchPolicy }).then(function (res) {
                return res.data.getTenantOnboardingList.results;
            });
        };
        this.updateTenantOnboardingStep = function (stepId, state, selection) {
            var variables = {
                tenantId: authentication.userTenant().uuid,
                stepId: stepId,
                variables: {
                    state: state,
                    selection: selection
                }
            };
            return client.mutate({ mutation: updateTenantOnboardingStep, variables: variables }).then(function (res) { return res.data.updateTenantOnboardingStep; });
        };
        this.updateTenantOnboarding = function (params, tenantId) {
            var variables = {
                tenantId: tenantId || authentication.userTenant().uuid,
                variables: params
            };
            return client.mutate({ mutation: updateTenantOnboarding, variables: variables }).then(function (res) { return res.data.updateTenantOnboarding; });
        };
        this.get = function (userId, options, token) {
            if (options === void 0) { options = {}; }
            var variables = {
                userId: userId,
                accessToken: token
            };
            // remove when we use update mutation properly
            return client
                .query(__assign(__assign({}, options), { query: getUserOnboarding, variables: variables }))
                .then(function (res) { return res.data.getUserOnboarding; })
                .catch(onboardingErrorHandler);
        };
        this.getOnboardingUrl = function (userId) {
            var variables = {
                userId: userId
            };
            return client
                .query({ query: getOnboardingUrl, variables: variables, fetchPolicy: "network-only" })
                .then(function (res) { return res.data.getOnboardingUrl; })
                .catch(onboardingErrorHandler);
        };
        this.resendWelcomeEmail = function (user, options) {
            if (options === void 0) { options = {}; }
            var variables = {
                userId: user.uuid
            };
            API.sentryIgnoreError(options, [codes.InitialOnboardingCompleted, codes.UserDisabled]);
            return client
                .query({ query: resendWelcomeEmailQuery, variables: variables })
                .then(function (res) { return res.data.resendWelcomeEmailQuery; })
                .catch(function (err) { return handleOnboardingDoesNotExist(err, user); })
                .catch(onboardingErrorHandler);
        };
        this.completeStep = function (user, step, token) {
            var variables = {
                userId: user.uuid,
                stepId: step,
                accessToken: token
            };
            return client
                .mutate({ mutation: completeUserOnboardingStep, variables: variables })
                .then(function (res) { return res.data.completeUserOnboardingStep; })
                .catch(onboardingErrorHandler);
        };
        this.create = function (user, options) {
            if (options === void 0) { options = {}; }
            var data = {
                userId: user.uuid,
                tenantId: user.tenant,
                roles: user.roles,
                email: user.email,
                source: user.source
            };
            return API.post("" + endpoints.createOnboarding(), data, options);
        };
    }
    return Onboarding;
}());
var onboarding = new Onboarding();
export var resendWelcomeEmail = onboarding.resendWelcomeEmail;
export var completeOnboardingStep = onboarding.completeStep;
export var getOnboarding = onboarding.get;
export var createOnboarding = onboarding.create;
export default onboarding;
